import React, { Component } from "react";
import axios from "axios";
import DataTable, { defaultThemes } from "react-data-table-component";
import { updateUser, deleteUser, downloadOTP, resetUserCredentials } from "../../UserFunctions";
import PropTypes from "prop-types";
import Message from "../../../utilityComponents/Message";
import ShadeLoader from "../../../utilityComponents/ShadeLoader";
import "../css/Datatable.css";
import "../css/AllUsers.css";

class FilterComponent extends Component {
    render() {
        return (
            <>
                <input
                    className="cus-filter-input"
                    id="search"
                    type="text"
                    placeholder="Filter By Name"
                    aria-label="Search Input"
                    value={this.props.filterText}
                    onChange={this.props.onFilter}
                />
                <button className="btn btn-info cus-filter-btn" onClick={this.props.onClear}>
                    X
                </button>
            </>
        );
    }
}

class DelConfirm extends Component {
    _delConfirm() {
        this.props.confirm(this.props.user.username, this.props.user.id);
    }
    render() {
        return (
            <div className="trans-shade">
                <div className="modal cus-modal" tabIndex="-1" id="myModal">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete User</h5>
                            </div>
                            <div className="modal-body">
                                <p>Please confirm to {'delete'} the User: {this.props.user.username}</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={this.props.cancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => this._delConfirm()}
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class ResetCredentialsConfirm extends Component {
    _resetConfirm() {
        this.props.confirm(this.props.user.username, this.props.user.id);
    }
    render() {
        return (
            <div className="trans-shade">
                <div className="modal cus-modal" tabIndex="-1" id="myModal">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Reset Credentials</h5>
                            </div>
                            <div className="modal-body">
                                <p>Please confirm to reset the credentials of User: {this.props.user.username}</p>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={this.props.cancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => this._resetConfirm()}
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class AllUsers extends Component {
    constructor() {
        super();
        this.state = {
            allUsersList: [],
            success: "",
            inputError: "",
            error: "",
            edit_user: false,
            edit_user_row: {},
            loading: true,
            delete_user: false,
            delete_user_row: {},
            reset_user_credentials: false,
            reset_user_credentials_row: {}
        };
        this.msgDefVal = {
            success: "",
            inputError: "",
            error: "",
        };
        this._cancelEdit = this._cancelEdit.bind(this);
        this._onEditConfirm = this._onEditConfirm.bind(this);
        this._cancelDelete = this._cancelDelete.bind(this);
        this._onDelConfirm = this._onDelConfirm.bind(this);
        this._cancelResetCredentials = this._cancelResetCredentials.bind(this);
        this._onResetCredentialsConfirm = this._onResetCredentialsConfirm.bind(this);
    }

    reDirToAddUsers() {
        this.props.history.push(`/register`);
    }

    componentDidMount() {
        this._fetchUsersList();
    }

    _fetchUsersList() {
        axios
            .get("/api/user/list")
            .then((response) => {
                console.log(response);
                let result = response.data.users.filter((item) => !item.is_current_user);
                this.setState({
                    allUsersList: result,
                    loading: false,
                });
            })
            .catch((error) => {
                console.log(error);
                const data = error.response.data;
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //    && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    const data = error.response.data;
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            loading: false,
                            error: data.message,
                        };
                    });
                } else {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            loading: false,
                            error: "Something Went Wrong, Please Try Again!!",
                        };
                    });
                }
            });
    }

    _onClickEdit(row) {
        this.setState((prevState) => {
            console.log(row);
            return {
                ...prevState,
                ...this.msgDefVal,
                edit_user: true,
                edit_user_row: row,
            };
        });
        console.log(this.state);
    }

    _cancelEdit() {
        this.setState((prevState) => {
            return {
                ...prevState,
                ...this.msgDefVal,
                edit_user: false,
                edit_user_row: {},
            };
        });
    }

    _onEditConfirm(username) {
        this.setState((prevState) => {
            return {
                ...prevState,
                ...this.msgDefVal,
                edit_user: false,
                edit_user_row: {},
                success: "User: " + username + " Data updated successfully",
            };
        });
        this._fetchUsersList();
    }

    _onClickDel(row) {
        this.setState((prevState) => {
            console.log(row);
            return {
                ...prevState,
                ...this.msgDefVal,
                delete_user: true,
                delete_user_row: row,
            };
        });
    }

    _cancelDelete() {
        this.setState((prevState) => {
            return {
                ...prevState,
                ...this.msgDefVal,
                delete_user: false,
                delete_user_row: {},
            };
        });
    }

    _onDelConfirm(username, id) {
        this.setState({
            loading: true,
        });
        deleteUser(id)
            .then((res) => {
                if (res && res.status === 200) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            loading: false,
                            delete_user: false,
                            delete_user_row: {},
                            success: "User: " + username + " Deleted Successfully",
                        };
                    });
                    this._fetchUsersList();
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                console.log(error.response);
                const data = error.response.data;
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        ...this.msgDefVal,
                        loading: false,
                        delete_user: false,
                        delete_user_row: {},
                        error: data.message,
                    };
                });
            });
    }

    _onClickDownloadOtp(row){
        this.setState({
            loading: true,
        });
        downloadOTP(row.id).then((response) => {
                console.log(response);
                let contentType = null;
                let filename = null;
                contentType = response.headers['content-type'];
                filename = response.headers['content-disposition'].split('filename=')[1];
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = filename;
                a.click();
                this.setState({
                    loading: false,
                    ...this.msgDefVal,
                    error: ''
                });
                window.URL.revokeObjectURL(url);
        }).catch((error) => {
                console.log(error);
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        ...this.msgDefVal,
                        loading: false,
                        error: error.response.data.message,
                    };
                });
        });
    }

    _onClickResetCredentials(row) {
        this.setState((prevState) => {
            return {
                ...prevState,
                ...this.msgDefVal,
                reset_user_credentials: true,
                reset_user_credentials_row: row,
            };
        });
    }

    _cancelResetCredentials() {
        this.setState((prevState) => {
            return {
                ...prevState,
                ...this.msgDefVal,
                reset_user_credentials: false,
                reset_user_credentials_row: {},
            };
        });
    }

    _onResetCredentialsConfirm(username, id) {
        this.setState({
            loading: true,
        });
        resetUserCredentials(id)
            .then((res) => {
                if (res && res.status === 200) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            loading: false,
                            reset_user_credentials: false,
                            reset_user_credentials_row: {},
                            success: "User: " + username + " credentials reset successfully",
                        };
                    });
                    this._fetchUsersList();
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                console.log(error.response);
                const data = error.response.data;
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        ...this.msgDefVal,
                        loading: false,
                        reset_user_credentials: false,
                        reset_user_credentials_row: {},
                        error: data.message,
                    };
                });
            });
    }

    render() {
        const customStyles = {
            header: {
                style: {
                    minHeight: "56px",
                },
            },
            headCells: {
                style: {
                    "&:not(:last-of-type)": {
                        borderRightStyle: "solid",
                        borderRightWidth: "1px",
                        borderRightColor: defaultThemes.default.divider.default,
                    },
                },
            },
            cells: {
                style: {
                    "&:not(:last-of-type)": {
                        borderRightStyle: "solid",
                        borderRightWidth: "1px",
                        borderRightColor: defaultThemes.default.divider.default,
                    },
                    fontSize: "15px",
                },
            },
        };
        const columns = [
            {
                name: "Full Name",
                selector: (row) => row.full_name,
                sortable: true,
                center: true,
            },
            {
                name: "Employee ID",
                selector: (row) => row.emp_id,
                sortable: true,
                center: true,
            },
            {
                name: "Email ID",
                selector: (row) => row.email_id,
                sortable: true,
                center: true,
                width: "220px !important",
            },
            {
                name: "Mobile No.",
                selector: (row) => row.contact,
                sortable: true,
                center: true,
            },
            {
                name: "Username",
                selector: (row) => row.username,
                sortable: true,
                center: true,
            },
            {
                name: "Role",
                selector: (row) => row.role_description,
                sortable: true,
                center: true,
            },
            {
                name: "Activation Status",
                selector: (row) => (row.is_active ? "Active" : "Inactive"),
                sortable: true,
                center: true,
            },
            {
                button: true,
                width: "150px !important",
                cell: (row) => (
                    <>
                        <button
                            className="btn btn-primary cus-action-btn"
                            onClick={() => this._onClickEdit(row)} title="Edit user"
                        >
                            <i className="fa fa-edit"></i>
                        </button>
                        {
                           !row.is_pwd_updated ?
                            <button
                                className="btn btn-warning cus-action-btn cus-mgn-lft-5"
                                onClick={() => this._onClickDownloadOtp(row)} title="Download otp credentials">
                                <i className="fa fa-download"></i>
                            </button> :
                             <button className="btn btn-warning cus-action-btn cus-mgn-lft-5"
                                onClick={() => this._onClickResetCredentials(row)} title="Reset user credentials">
                                <i className="fa fa-sync"></i>
                            </button>
                        }
                        <button className="btn btn-danger cus-action-btn cus-mgn-lft-5"
                            onClick={() => this._onClickDel(row)} title="Delete user">
                            <i className="fa fa-trash"></i>
                        </button>
                    </>
                ),
            },
        ];
        return (
            <React.Fragment>
        
                {this.state.loading ? <ShadeLoader /> : null}
                <div className="row" style={{ backgroundColor: "#f1f1f1" }}>
                    <div className="col-12" style={{ paddingLeft: "4%", paddingRight: "4%" }}>
                        <div className="row cus-head-div">
                            <div className="col-9">
                                <div className="page-heading">
                                    <h2 className="page-title">Registered Users</h2>
                                </div>
                            </div>
                            <div className="col-3">
                                <button
                                    className="btn btn-warning cus-view-btn"
                                    onClick={() => this.reDirToAddUsers()}
                                >
                                    <i className="fa fa-address-card"></i> Add Users
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {this.state.error && (
                                    <Message variant="danger">{this.state.error}</Message>
                                )}
                            </div>
                            <div className="col-12">
                                {this.state.success && (
                                    <Message variant="success">{this.state.success}</Message>
                                )}
                            </div>
                            <div className="col-12">
                                {this.state.inputError && (
                                    <Message variant="warning">{this.state.inputError}</Message>
                                )}
                            </div>
                        </div>
                        {this.state.edit_user ? (
                            <EditUser
                                user={this.state.edit_user_row}
                                cancelEdit={this._cancelEdit}
                                onConfirm={this._onEditConfirm}
                            />
                        ) : null}
                        {this.state.delete_user ? (
                            <DelConfirm
                                user={this.state.delete_user_row}
                                cancel={this._cancelDelete}
                                confirm={this._onDelConfirm}
                            />
                        ) : null}
                        {this.state.reset_user_credentials ? (
                            <ResetCredentialsConfirm
                                user={this.state.reset_user_credentials_row}
                                cancel={this._cancelResetCredentials}
                                confirm={this._onResetCredentialsConfirm}
                            />
                        ) : null}
                        <div className="row">
                            <div className="col-12" style={{ backgroundColor: "white" }}>
                                <DataTable
                                    columns={columns}
                                    data={this.state.allUsersList}
                                    pagination
                                    striped
                                    highlightOnHover
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

AllUsers.propTypes = {
    history: PropTypes.string,
};

AllUsers.defaultProps = {
    history: [],
};

class EditUser extends Component {
    constructor(props) {
        super(props);

        let first_name = this.props.user.full_name.split(" ")[0];
        let last_name = this.props.user.full_name.split(" ")[1];

        this.state = {
            first_name: first_name,
            last_name: last_name,
            email: this.props.user.email_id,
            emp_id: this.props.user.emp_id,
            mobile_no: this.props.user.contact,
            role: this.props.user.role,
            activation_status: this.props.user.is_active,
            accessibleRoles: [],
            success: "",
            inputError: "",
            error: "",
            loading: true,
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.defaultValues = this.props.user;

        this.msgDefVal = {
            error: "",
            success: "",
            inputError: "",
        };
    }

    onChange(e) {
        if (e.target.name == "activation_status") {
            this.setState({ [e.target.name]: e.target.checked });
        } else {
            this.setState({ [e.target.name]: e.target.value });
        }
    }

    onSubmit(e) {
        e.preventDefault();
        let validRes = this.validateInputFields();
        if (!validRes["stat"]) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    ...this.msgDefVal,
                    inputError: validRes["msg"],
                };
            });
            return;
        } else {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    ...this.msgDefVal,
                    loading: true,
                };
            });
        }

        const userInfo = {
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            email_id: this.state.email,
            emp_id: this.state.emp_id,
            contact: this.state.mobile_no,
            role: this.state.role,
            username: this.state.email.split("@")[0],
            full_name: this.state.first_name + " " + this.state.last_name,
            activation_status: this.state.activation_status,
        };

        updateUser(userInfo, this.props.user.id)
            .then((res) => {
                if (res && res.status === 200) {
                    let message = res.data.message;
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            ...this.msgDefVal,
                            loading: false,
                            success: message,
                        };
                    });
                    this.props.onConfirm(userInfo.username);
                } else {
                    console.log("Execption Occurred");
                }
            })
            .catch((error) => {
                console.log(error.response);
                const data = error.response.data;
                let errorMsg = data.message;
                if (errorMsg == "Input payload validation failed") {
                    let errorKeys = Object.keys(data.errors).join();
                    errorMsg = errorMsg + " (" + errorKeys + ")";
                }
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        ...this.msgDefVal,
                        loading: false,
                        error: errorMsg,
                    };
                });
            });
    }

    validateInputFields() {
        let specialCharListName = /^[A-Za-z]+$/;
        let specialCharListEmailId = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        let specialCharListMobNo = /^[0-9]+$/;
        let specialCharListEmpId = /^[A-Za-z0-9]+$/;

        if (
            this.state.first_name.includes(" ") ||
            !specialCharListName.test(this.state.first_name)
        ) {
            return {
                stat: false,
                msg: "First name cannot have spaces or special characters or numbers",
            };
        } else if (
            this.state.last_name.includes(" ") ||
            !specialCharListName.test(this.state.last_name)
        ) {
            return {
                stat: false,
                msg: "Last name cannot have spaces or special characters or numbers",
            };
        } else if (!specialCharListEmailId.test(this.state.email)) {
            return {
                stat: false,
                msg: "Please enter a valid Email ID",
            };
        } else if (
            !specialCharListMobNo.test(this.state.mobile_no) ||
            isNaN(this.state.mobile_no) || this.state.mobile_no.length>11
        ) {
            return {
                stat: false,
                msg: "Please enter a valid Mobile No.",
            };
        } else if (!specialCharListEmpId.test(this.state.emp_id)) {
            return {
                stat: false,
                msg: "Please enter a valid Employee ID",
            };
        } else if (this.state.role == "") {
            return {
                stat: false,
                msg: "Please select a valid Role",
            };
        } else {
            return {
                stat: true,
                msg: "All Fields Validated",
            };
        }
    }

    componentWillMount() {
        axios
            .get("/api/user/accessible-roles")
            .then((response) => {
                console.log(response);
                this.setState({
                    accessibleRoles: response.data.roles,
                    loading: false,
                });
            })
            .catch((error) => {
                console.log(error);
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        ...this.msgDefVal,
                        loading: false,
                        error: "Coudn't fetch the Roles, Please Reload/Re-login.",
                    };
                });
            });
    }

    _cancelEdit() {
        if (this.updateInitiated) {
        } else {
            this.props.cancelEdit();
        }
    }

    render() {
        let rolesDropDown = [<option value=""> </option>];
        this.state.accessibleRoles.map((elem) => {
            rolesDropDown.push(<option value={elem[0]}> {elem[1]}</option>);
        });
        return (
            <React.Fragment>
                <div className="trans-shade">
                    {this.state.loading ? <ShadeLoader /> : null}
                    <div className="card cus-edit-ibox">
                        <div className="card-title cus-card-title">
                            <b> Update User details </b>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div
                                    className="col-12"
                                    style={{ paddingLeft: "4%", paddingRight: "4%" }}
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            {this.state.error && (
                                                <Message variant="danger">
                                                    {this.state.error}
                                                </Message>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            {this.state.success && (
                                                <Message variant="success">
                                                    {this.state.success}
                                                </Message>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            {this.state.inputError && (
                                                <Message variant="warning">
                                                    {this.state.inputError}
                                                </Message>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-12"
                                            style={{ backgroundColor: "white" }}
                                        >
                                            <div
                                                className="row"
                                                style={{ backgroundColor: "white" }}
                                            >
                                                <div className="col-12">
                                                    <form validate onSubmit={this.onSubmit}>
                                                        <div className="row">
                                                            <div className="col-6">
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="first_name"
                                                                        className="card-title"
                                                                        style={{
                                                                            color: "#464646",
                                                                            fontSize:
                                                                                "100% !important",
                                                                        }}
                                                                    >
                                                                        First name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="first_name"
                                                                        placeholder="Enter your first name"
                                                                        value={
                                                                            this.state.first_name
                                                                        }
                                                                        onChange={this.onChange}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="last_name"
                                                                        className="card-title"
                                                                        style={{
                                                                            color: "#464646",
                                                                            fontSize:
                                                                                "100% !important",
                                                                        }}
                                                                    >
                                                                        Last name
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="last_name"
                                                                        placeholder="Enter your last name"
                                                                        value={this.state.last_name}
                                                                        onChange={this.onChange}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-row">
                                                            <div className="col-4 cus-mar-top">
                                                                <label
                                                                    htmlFor="email"
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#464646",
                                                                        fontSize: "100% !important",
                                                                    }}
                                                                >
                                                                    Email address :
                                                                </label>
                                                            </div>
                                                            <div className="col">
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    name="email"
                                                                    placeholder="Enter email"
                                                                    value={this.state.email}
                                                                    readOnly={true}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-row">
                                                            <div className="col-4 cus-mar-top">
                                                                <label
                                                                    htmlFor="mobile_no"
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#464646",
                                                                        fontSize: "100% !important",
                                                                    }}
                                                                >
                                                                    Mobile No. :
                                                                </label>
                                                            </div>
                                                            <div className="col">
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    name="mobile_no"
                                                                    placeholder="Mobile No."
                                                                    value={this.state.mobile_no}
                                                                    onChange={this.onChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-row">
                                                            <div className="col-4 cus-mar-top">
                                                                <label
                                                                    htmlFor="emp_id"
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#464646",
                                                                        fontSize: "100% !important",
                                                                    }}
                                                                >
                                                                    Employee ID :
                                                                </label>
                                                            </div>
                                                            <div className="col">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="emp_id"
                                                                    placeholder="Employee ID"
                                                                    value={this.state.emp_id}
                                                                    onChange={this.onChange}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-row">
                                                            <div className="col-4 cus-mar-top">
                                                                <label
                                                                    htmlFor="role"
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#464646",
                                                                        fontSize: "100% !important",
                                                                    }}
                                                                >
                                                                    Assign Role :
                                                                </label>
                                                            </div>
                                                            <div className="col">
                                                                <select
                                                                    type="text"
                                                                    className="form-control"
                                                                    name="role"
                                                                    placeholder="Assign Role"
                                                                    value={this.state.role}
                                                                    onChange={this.onChange}
                                                                    required
                                                                >
                                                                    {rolesDropDown}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="form-row">
                                                            <div className="col-4 cus-mar-top">
                                                                <label
                                                                    htmlFor="activation_status"
                                                                    className="card-title"
                                                                    style={{
                                                                        color: "#464646",
                                                                        fontSize: "100% !important",
                                                                    }}
                                                                >
                                                                    Status :
                                                                </label>
                                                            </div>
                                                            <div className="col">
                                                                <label
                                                                    className="ui-checkbox ui-checkbox-info"
                                                                    style={{ marginTop: "1%" }}
                                                                >
                                                                    <input
                                                                        className="mail-check"
                                                                        type="checkbox"
                                                                        name="activation_status"
                                                                        checked={
                                                                            this.state
                                                                                .activation_status
                                                                        }
                                                                        onChange={this.onChange}
                                                                    />
                                                                    <b>Active</b>
                                                                    <span className="input-span"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div className="col-5"></div>
                                                                <div className="col-3">
                                                                    <a
                                                                        className="btn btn-danger btn-block cus-cancel-a"
                                                                        onClick={() =>
                                                                            this._cancelEdit()
                                                                        }
                                                                    >
                                                                        Cancel
                                                                    </a>
                                                                </div>
                                                                <div className="col-3">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-success btn-block"
                                                                    >
                                                                        Update
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default AllUsers;
